import { render, staticRenderFns } from "./ReceiptStatusSelector.vue?vue&type=template&id=1fc8eb90&scoped=true"
import script from "./ReceiptStatusSelector.vue?vue&type=script&lang=js"
export * from "./ReceiptStatusSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc8eb90",
  null
  
)

export default component.exports